(() => {
  // Approved collection-directory feature. Keep behavior paired with the guarded Liquid section.
  document.querySelectorAll('[data-plant-list-builder]').forEach((builder) => {
    const choices = [...builder.querySelectorAll('[data-filter-value]')];
    const tray = builder.querySelector('[data-plant-list-tray]');
    const selections = builder.querySelector('[data-plant-list-selections]');
    const submit = builder.querySelector('[data-plant-list-submit]');
    const clear = builder.querySelector('[data-plant-list-clear]');
    const catalogUrl = builder.dataset.catalogUrl || '/search';

    const selectedChoices = () => choices.filter((choice) => choice.getAttribute('aria-pressed') === 'true');

    const buildUrl = (selected) => {
      const url = new URL(catalogUrl, window.location.origin);
      const traits = selected.filter((choice) => choice.dataset.filterGroup === 'trait');
      const types = selected.filter((choice) => choice.dataset.filterGroup === 'type');

      traits.forEach((choice) => url.searchParams.append('filter.p.tag', choice.dataset.filterValue));
      types.forEach((choice) => url.searchParams.append('filter.p.product_type', choice.dataset.filterValue));
      url.searchParams.set('q', '*');
      url.searchParams.set('type', 'product');
      url.searchParams.set('options[prefix]', 'last');
      return url;
    };

    const render = () => {
      const selected = selectedChoices();
      tray.hidden = selected.length === 0;
      selections.replaceChildren();

      selected.forEach((choice) => {
        const button = document.createElement('button');
        const label = choice.textContent.trim();
        button.type = 'button';
        button.className = 'plant-list-builder__selection';
        button.textContent = `${label} ×`;
        button.setAttribute('aria-label', `Remove ${label}`);
        button.addEventListener('click', () => {
          choice.setAttribute('aria-pressed', 'false');
          render();
        });
        selections.append(button);
      });

      submit.href = buildUrl(selected).toString();
    };

    choices.forEach((choice) => {
      choice.addEventListener('click', () => {
        const isSelected = choice.getAttribute('aria-pressed') === 'true';
        choice.setAttribute('aria-pressed', String(!isSelected));
        render();
      });
    });

    clear.addEventListener('click', () => {
      choices.forEach((choice) => choice.setAttribute('aria-pressed', 'false'));
      render();
    });
  });
})();
